import { Link } from "react-router-dom";
import { Download, Edit, Trash2 } from "react-feather";
import {
  ButtonGroup,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import { admins } from "../../../../Constant";
import { FEATURE_FUNCTION_SELECTION } from "../../../../Constant/FeatureSelection";
import {
  BaruDiajukan,
  canAccessWhenStatus,
  Dibayarkan,
  DipertanggungJawabkan,
  getStatusData,
  STATUS_DATA_TYPE,
} from "../../../../Constant/StatusData";
import {
  formatDate,
  formatRP,
  getUser,
} from "../../../../Utils/externalFunctions";
import {
  getDarkDropdown,
  getStatusBadge,
} from "../../../../Utils/otherFunctions";
import DataTableTitle from "../../../DataTableComponents/DataTableTitle";
import DateSortFunction from "../../../DataTableComponents/DateSortFunction";

const getUMKColumns = ({
  themeContext,
  handleEditStatusUMK,
  handleDeleteUMK,
}) => {
  const columns = [
    {
      name: <DataTableTitle text={"Kode UMK"} />,
      selector: (row) => row.kode_umk,
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"DPSJ"} />,
      selector: (row) => row.id_unit_kerja,
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Diajukan Oleh"} />,
      selector: (row) => row.diajukan_oleh,
      sortable: true,
    },
    {
      name: <DataTableTitle text={"Tanggal Dibuat"} />,
      selector: (row) => formatDate(row.date_created),
      sortable: true,
      wrap: true,
      sortFunction: DateSortFunction("date_created"),
    },
    {
      name: <DataTableTitle text={"Tanggal Mulai"} />,
      selector: (row) => formatDate(row.tanggal_mulai),
      sortable: true,
      wrap: true,
      sortFunction: DateSortFunction("tanggal_mulai"),
    },
    {
      name: <DataTableTitle text={"Tanggal Selesai"} />,
      selector: (row) => formatDate(row.tanggal_selesai),
      sortable: true,
      wrap: true,
      sortFunction: DateSortFunction("tanggal_selesai"),
    },
    {
      name: <DataTableTitle text={"Batas Akhir"} />,
      selector: (row) => formatDate(row.batas_akhir),
      sortable: true,
      wrap: true,
      sortFunction: DateSortFunction("batas_akhir"),
    },
    {
      name: <DataTableTitle text={"Keterangan"} />,
      selector: (row) => row.keterangan,
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Status"} />,
      selector: (row) => {
        const statusData = getStatusData(
          row.id_status_umk,
          STATUS_DATA_TYPE.UMK
        );
        return getStatusBadge(statusData);
      },
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Nilai (Rp.)"} />,
      selector: (row) => parseInt(row.nilai),
      sortable: true,
      format: (row) => formatRP(row.nilai),
    },
  ];

  FEATURE_FUNCTION_SELECTION.UMK.Operasi &&
    columns.push(
      getUMKOperasiColumn({
        themeContext,
        handleEditStatusUMK,
        handleDeleteUMK,
      })
    );

  return columns;
};

const getUMKOperasiColumn = ({
  themeContext,
  handleEditStatusUMK,
  handleDeleteUMK,
}) => ({
  name: <DataTableTitle text={"Operasi"} />,
  cell: (row) => {
    const canAccess = canAccessWhenStatus(
      row.id_status_umk,
      STATUS_DATA_TYPE.UMK,
      [BaruDiajukan, DipertanggungJawabkan, Dibayarkan]
    );
    return (
      <ButtonGroup>
        {/* <UncontrolledDropdown direction="up"> */}
        <UncontrolledDropdown>
          <DropdownToggle caret></DropdownToggle>
          <DropdownMenu>
            {(canAccess || admins.includes(getUser())) &&
              FEATURE_FUNCTION_SELECTION.UMK.Update && (
                <>
                  <Link to={`${process.env.PUBLIC_URL}/umk/editumk/${row.pk}`}>
                    <DropdownItem
                      className={`d-flex align-items-center gap-2 ${getDarkDropdown(
                        themeContext
                      )}`}
                    >
                      <Edit size={12} />
                      Ubah
                    </DropdownItem>
                  </Link>
                  <DropdownItem divider />
                </>
              )}

            {admins.includes(getUser()) &&
              FEATURE_FUNCTION_SELECTION.UMK.UpdateStatus && (
                <>
                  <DropdownItem
                    className={`d-flex align-items-center gap-2 ${getDarkDropdown(
                      themeContext
                    )}`}
                    onClick={() => handleEditStatusUMK(row)}
                  >
                    <Edit size={12} />
                    Edit Status
                  </DropdownItem>
                  <DropdownItem divider />
                </>
              )}

            {(canAccess || admins.includes(getUser())) &&
              FEATURE_FUNCTION_SELECTION.UMK.Delete && (
                <>
                  <DropdownItem
                    className={`text-danger d-flex align-items-center gap-2 ${getDarkDropdown(
                      themeContext
                    )}`}
                    onClick={() => handleDeleteUMK(row)}
                  >
                    <Trash2 size={12} />
                    Hapus
                  </DropdownItem>
                  <DropdownItem divider />
                </>
              )}

            {FEATURE_FUNCTION_SELECTION.UMK.CetakLaporan && (
              <DropdownItem>
                <Link
                  className={"d-flex align-items-center gap-2"}
                  to={`${process.env.PUBLIC_URL}/umk/document/${row.pk}`}
                  target="_blank"
                >
                  <Download size={12} />
                  Cetak Laporan
                </Link>
              </DropdownItem>
            )}
          </DropdownMenu>
        </UncontrolledDropdown>
      </ButtonGroup>
    );
  },
});

export default getUMKColumns;
